export default "__VITE_ASSET__B_$48bx5__"